<template>
    <div>
        <Card>
            <transition name="fade">
                <Row v-if="mainTable.sarchCardShow" :gutter="16">
                    <Col span="24">
                        <search-card
                            :form="mainTable.searchForm"
                            :table-load-event="
                                getDistributionStationTableRecords
                            "
                            :table-search="mainTable.tableSearch"
                        />
                    </Col>
                </Row>
            </transition>

            <Row :gutter="16">
                <Col span="24">
                    <div class="global-tool-bar">
                        <div class="left-bar">
                            <span class="title">转运站管理</span>
                        </div>
                        <div class="right-bar">
                            <Button
                                v-if="$checkAccessArray(['S'])"
                                size="small"
                                class="btns"
                                shape="circle"
                                type="success"
                                icon="ios-add-circle-outline"
                                @click="onDistributionStationCreate"
                                >新增</Button
                            >

                            <Button
                                type="primary"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-search"
                                @click="
                                    mainTable.sarchCardShow =
                                        !mainTable.sarchCardShow
                                "
                                >搜索</Button
                            >
                        </div>
                    </div>
                </Col>
            </Row>

            <!-- <Row v-if="distributionStationFormShow"
                :gutter="16">
                <Form :label-width="85"
                    label-position="right">
                    <Col span="6">
                    <FormItem label="转运站名称">
                        <Input v-model="distributionStationForm.distributionStationName"></Input>
                    </FormItem>
                    </Col>
                    <Col span="4">
                    <FormItem label="所属区域">
                        <Select v-model="distributionStationForm.distributionStationAreaUuid"
                            filterable>
                            <Option v-for="item in areaSource"
                                :key="item.areaUuid"
                                :value="item.areaUuid">{{ item.areaName }}</Option>
                        </Select>
                    </FormItem>
                    </Col>
                    <Col span="4">
                    <FormItem label="默认运费">
                        <Input v-model="distributionStationForm.distributionStationDefaultLogisticsPerVolumePrice"></Input>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem label="地址">
                        <Input v-model="distributionStationForm.distributionStationAddress"></Input>
                    </FormItem>
                    </Col>
                    <Col span="2">
                    <Button type="success"
                        class="form-button"
                        @click="onSave">保存</Button>
                    <Button type="text"
                        class="form-button"
                        @click="onCancel">取消</Button>
                    </Col>
                </Form>
            </Row> -->

            <Row :gutter="16">
                <Col span="24">
                    <stand-pagination-table
                        :columns="mainTable.columns"
                        :data="mainTable.data"
                        :loading="mainTable.loading"
                        :table-search="mainTable.tableSearch"
                        :table-load-event="getDistributionStationTableRecords"
                    />
                </Col>
            </Row>
        </Card>

        <Modal
            v-model="distributionStationFormShow"
            title="转运站信息"
            width="60"
        >
            <Form
                label-position="top"
                :model="distributionStationForm"
                ref="formDistributionStation"
            >
                <Row :gutter="16">
                    <Col span="6">
                        <FormItem label="转运站编号">
                            <Input
                                v-model="
                                    distributionStationForm.distributionStationCode
                                "
                            ></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="转运站名称">
                            <Input
                                v-model="
                                    distributionStationForm.distributionStationName
                                "
                            ></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="转运站地点">
                            <Input
                                v-model="
                                    distributionStationForm.distributionStationAddress
                                "
                            ></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="6">
                        <FormItem label="省份">
                            <Select
                                v-model="
                                    distributionStationForm.distributionStationProvince
                                "
                                filterable
                                @on-change="onProvinceChange"
                            >
                                <Option
                                    v-for="item in provinceOptions"
                                    :key="item.regionUuid"
                                    :value="item.regionUuid"
                                    >{{ item.regionName }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>

                    <Col span="6">
                        <FormItem label="城市">
                            <Select
                                v-model="
                                    distributionStationForm.distributionStationCity
                                "
                                filterable
                                @on-change="onCityChange"
                            >
                                <Option
                                    v-for="item in cityOptions"
                                    :key="item.regionUuid"
                                    :value="item.regionUuid"
                                    >{{ item.regionName }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>

                    <Col span="6">
                        <FormItem label="区域">
                            <Select
                                v-model="
                                    distributionStationForm.distributionStationDist
                                "
                                filterable
                            >
                                <Option
                                    v-for="item in distOptions"
                                    :key="item.regionUuid"
                                    :value="item.regionUuid"
                                    >{{ item.regionName }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                    <!-- <Col span="4">
                <FormItem label="所属区域">
                    <Select v-model="distributionStationForm.distributionStationAreaUuid"
                        filterable>
                        <Option v-for="item in areaSource"
                            :key="item.areaUuid"
                            :value="item.areaUuid">{{ item.areaName }}</Option>
                    </Select>
                </FormItem>
                </Col> -->
                    <Col span="6">
                        <FormItem label="街道">
                            <Input
                                v-model="
                                    distributionStationForm.distributionStationStreet
                                "
                            ></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="6">
                        <FormItem label="详细地址">
                            <Input
                                v-model="
                                    distributionStationForm.distributionStationFullAddress
                                "
                            ></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="运营部门">
                            <Input
                                v-model="
                                    distributionStationForm.distributionStationOperateDepartment
                                "
                            ></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="负责人">
                            <Input
                                v-model="
                                    distributionStationForm.distributionStationLeader
                                "
                            ></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="联系电话">
                            <Input
                                v-model="
                                    distributionStationForm.distributionStationPhone
                                "
                            ></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="6">
                        <FormItem label="X坐标">
                            <Input
                                v-model="
                                    distributionStationForm.distributionStationX
                                "
                            ></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="Y坐标">
                            <Input
                                v-model="
                                    distributionStationForm.distributionStationY
                                "
                            ></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="默认运费">
                            <Input
                                v-model="
                                    distributionStationForm.distributionStationDefaultLogisticsPerVolumePrice
                                "
                            ></Input>
                        </FormItem>
                    </Col>
                    <Col span="6">
                        <FormItem label="公司" prop="company">
                            <Select
                                v-model="distributionStationForm.companyUuid"
                                clearable
                                filterable
                            >
                                <Option
                                    v-for="item in companyList"
                                    :key="item.id"
                                    :value="item.id"
                                    >{{ item.name }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                    <!-- <Col span="6">
                    <FormItem label="用友部门" prop="distributionStationYsDeptCode">
                        <Select v-model="distributionStationForm.distributionStationYsDeptCode" clearable filterable
                            @on-select="onSelectYSDept">
                            <Option v-for="item in ySDeptList" :key="item.code" :value="item.code">{{ item.code }} - {{
                                item.name}}</Option>
                        </Select>
                    </FormItem>
                    </Col> -->
                </Row>
                <Row>
                    <Col span="6">
                        <FormItem label="部门" prop="department">
                            <Select
                                v-model="distributionStationForm.departmentUuid"
                                clearable
                                filterable
                            >
                                <Option
                                    v-for="item in departmentList"
                                    :key="item.departmentUuid"
                                    :value="item.departmentUuid"
                                    >{{ item.departmentName }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="primary" @click="onSave">确认</Button>
                <Button
                    type="error"
                    @click="distributionStationFormShow = false"
                    >取消</Button
                >
            </div>
        </Modal>

        <Modal
            v-model="distributionStationYsDeptFormShow"
            title="修改YS部门"
            width="400"
        >
            <Form
                label-position="top"
                :rules="ruleValidate"
                :model="distributionStationForm"
                ref="formDistributionStationYsDept"
            >
                <Row :gutter="16">
                    <Col span="20">
                        <FormItem label="转运站编号">
                            <Input
                                v-model="
                                    distributionStationForm.distributionStationCode
                                "
                            ></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="16">
                    <Col span="20">
                        <FormItem label="转运站名称">
                            <Input
                                v-model="
                                    distributionStationForm.distributionStationName
                                "
                            ></Input>
                        </FormItem>
                    </Col>
                </Row>

                <Row :gutter="16">
                    <Col span="20">
                        <FormItem
                            label="用友部门"
                            prop="distributionStationYsDeptCode"
                        >
                            <Select
                                v-model="
                                    distributionStationForm.distributionStationYsDeptCode
                                "
                                clearable
                                filterable
                                @on-select="onSelectYSDept"
                            >
                                <Option
                                    v-for="item in ySDeptList"
                                    :key="item.code"
                                    :value="item.code"
                                    >{{ item.code }} - {{ item.name }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="primary" @click="onSaveYsDept">确认</Button>
                <Button
                    type="error"
                    @click="distributionStationYsDeptFormShow = false"
                    >取消</Button
                >
            </div>
        </Modal>

        <DistributionStationToCustomerCost
            ref="distributionStationToCustomerCostModal"
        />
        <DistributionStationBlockDist ref="distributionStationBlockDistModal" />
    </div>
</template>

<script>
import search from "@/libs/search";
import SearchCard from "@/components/searchCard/searchCard.vue";
import StandPaginationTable from "@/components/standard-pagination-table/StandPaginationTable";
import {
    FORM_EDIT_MODE_CREATE,
    FORM_EDIT_MODE_MODIFY
} from "@/view/mixins/form-edit-mode";
import { numberToFixedString } from "@/components/number-input/display-format";
import DecimalInput from "@/components/number-input/decimal-input";
import DistributionStationToCustomerCost from "./distributionStation-to-customer-cost";
import { getYSDeptList } from "@/api/modules/system-management/seedFarm-management";
import DistributionStationBlockDist from "./distributionStation-block-dist";
import {
    statusFormat,
    STATUS_ACTIVE,
    STATUS_INACTIVE
} from "@/libs/baseModelFormat";
import { getDepartmentList } from "@/api/modules/system-management/department-management";
import { getCompanyList } from "@/api/modules/system-management/company-management";
import {
    getDistributionStationList,
    pageInit4DistributionStationEdit,
    saveDistributionStation,
    saveDistributionStationYsDept
} from "@/api/modules/system-management/distributionStation-management";

export default {
    name: "DistributionStationList",
    components: {
        StandPaginationTable,
        DecimalInput,
        SearchCard,
        DistributionStationToCustomerCost,
        DistributionStationBlockDist
    },
    data() {
        return {
            FORM_EDIT_MODE_CREATE,
            departmentList: [],
            companyList: [],
            distributionStationForm: {
                formEditMode: "",
                distributionStationUuid: "",
                distributionStationName: "",
                distributionStationAddress: "",
                distributionStationAreaUuid: "",
                distributionStationType: "",
                distributionStationDefaultLogisticsPerVolumePrice: 0,
                distributionStationProvince: "",
                distributionStationCity: "",
                distributionStationDist: "",
                distributionStationStreet: "",
                distributionStationFullAddress: "",
                distributionStationOperateDepartment: "",
                distributionStationLeader: "",
                distributionStationPhone: "",
                distributionStationX: "",
                distributionStationY: "",
                distributionStationCode: "",
                distributionStationYsDeptId: "",
                distributionStationYsDeptCode: "",
                distributionStationYsDeptName: "",
                departmentUuid: "",
                companyUuid: ""
            },
            distributionStationFormShow: false,
            distributionStationYsDeptFormShow: false,
            mainTable: {
                columns: [
                    {
                        title: "行号",
                        type: "index",
                        width: 60,
                        align: "center"
                    },
                    {
                        title: "转运站编号",
                        key: "distributionStationCode",
                        align: "center"
                    },
                    {
                        title: "转运站名称",
                        key: "distributionStationName",
                        align: "center"
                    },
                    {
                        title: "关联用友部门",
                        key: "distributionStationYsDeptCode",
                        align: "center"
                    },
                    {
                        title: "关联用友部门编号",
                        key: "distributionStationYsDeptName",
                        align: "center"
                    },
                    {
                        title: "转运站地址",
                        key: "distributionStationAddress",
                        align: "center"
                    },
                    { title: "省", key: "provinceName", align: "center" },
                    { title: "市", key: "cityName", align: "center" },
                    { title: "区", key: "distName", align: "center" },
                    {
                        title: "街道",
                        key: "distributionStationStreet",
                        align: "center"
                    },
                    {
                        title: "运营部门",
                        key: "distributionStationOperateDepartment",
                        align: "center"
                    },
                    {
                        title: "负责人",
                        key: "distributionStationLeader",
                        align: "center"
                    },
                    {
                        title: "电话",
                        key: "distributionStationPhone",
                        align: "center"
                    },
                    {
                        title: "状态",
                        key: "distributionStationStatus",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "span",
                                    {},
                                    statusFormat(
                                        params.row.distributionStationStatus
                                    )
                                )
                            ]);
                        }
                    },
                    {
                        title: "操作",
                        key: "action",
                        align: "center",
                        width: 180,
                        render: (h, params) => {
                            const btns = [];
                            if (this.$checkAccessArray(["S", "D"])) {
                                btns.push(
                                    h(
                                        "Button",
                                        {
                                            props: {
                                                type: "text",
                                                size: "small"
                                            },
                                            style: {},
                                            on: {
                                                click: () => {
                                                    this.onDistributionStationUpdate(
                                                        params.row
                                                    );
                                                }
                                            }
                                        },
                                        "编辑"
                                    )
                                );

                                // btns.push(h('Button', {
                                //     props: {
                                //         type: 'text',
                                //         size: 'small',
                                //         to: {
                                //             name: 'distributionStation-product-store',
                                //             query: {
                                //                 distributionStationUuid: params.row.distributionStationUuid
                                //             }
                                //         }
                                //     }
                                // }, '仓存'));

                                // btns.push(h('Button', {
                                //     props: {
                                //         type: 'text',
                                //         size: 'small',
                                //         to: {
                                //             name: 'distributionStation-delivery-check',
                                //             query: {
                                //                 distributionStationUuid: params.row.distributionStationUuid
                                //             }
                                //         }
                                //     }
                                // }, '送货单质检'));
                            }

                            if (this.$checkAccessArray(["S","R"])) {
                                btns.push(
                                    h(
                                        "Button",
                                        {
                                            props: {
                                                type: "text",
                                                size: "small"
                                            },
                                            on: {
                                                click: () => {
                                                    this.onDistributionStationYsDeptUpdate(
                                                        params.row
                                                    );
                                                }
                                            }
                                        },
                                        "编辑YS部门"
                                    )
                                );
                            }

                            if (this.$checkAccessArray(["D"])) {
                                btns.push(
                                    h(
                                        "Button",
                                        {
                                            props: {
                                                type: "text",
                                                size: "small"
                                            },
                                            on: {
                                                click: () => {
                                                    this.$refs.distributionStationToCustomerCostModal.showModal();
                                                }
                                            }
                                        },
                                        "运费设置"
                                    )
                                );

                                // btns.push(h('Button', {
                                //     props: {
                                //         type: 'text',
                                //         size: 'small'

                                //     },
                                //     on: {
                                //         click: () => {
                                //             this.$refs.distributionStationBlockDistModal.showModal();
                                //         }
                                //     }
                                // }, '禁售区域'));
                            }

                            return h("div", btns);
                        }
                    }
                ],
                data: [],
                sarchCardShow: false,
                loading: false,
                tableSearch: search.getSearchParams(),
                searchForm: [
                    {
                        label: "转运站编号",
                        type: "Input",
                        value: "",
                        name: "distributionStationCode",
                        sql: "like"
                    },
                    {
                        label: "转运站名称",
                        type: "Input",
                        value: "",
                        name: "distributionStationName",
                        sql: "like"
                    },
                    {
                        label: "负责人",
                        type: "Input",
                        value: "",
                        name: "distributionStationLeader",
                        sql: "like"
                    },
                    {
                        label: "状态",
                        type: "Select",
                        name: "distributionStationStatus",
                        sql: "in",
                        options: [
                            { value: 1, key: "激活" },
                            { value: -1, key: "冻结" }
                        ]
                    }
                ]
            },
            areaSource: [],
            allRegionInfo: [],
            provinceOptions: [],
            cityOptions: [],
            distOptions: [],
            ySDeptList: [],
            ruleValidate: {
                distributionStationYsDeptCode: [
                    {
                        required: true,
                        message: "请选择用友部门",
                        trigger: "change"
                    }
                ]
            }
        };
    },
    mounted() {
        this.getDepartmentList();
        this.getCompanyList();
        // this.$Spin.show();
        pageInit4DistributionStationEdit()
            .then((res) => {
                // this.$Spin.hide();
                if (res.code === 0) {
                    this.areaSource = res.data.area.records.map((item) => {
                        return {
                            areaUuid: item.areaUuid,
                            areaName: item.areaName
                        };
                    });

                    this.getDistributionStationTableRecords();
                    this.getYSDeptList();
                }
            })
            .catch(() => {
                // this.$Spin.hide();
            });
    },
    methods: {
        onProvinceChange(provinceUuid) {
            this.distributionStationForm.distributionStationDist = "";
            this.distOptions = [];
            this.distributionStationForm.distributionStationCity = "";
            this.cityOptions = this.allRegionInfo.filter(
                (r) => r.regionType === 2 && r.regionParentUuid === provinceUuid
            );
        },
        onCityChange(cityUuid) {
            this.distributionStationForm.distributionStationDist = "";
            this.distOptions = this.allRegionInfo.filter(
                (r) => r.regionType === 3 && r.regionParentUuid === cityUuid
            );
        },
        getDistributionStationTableRecords(reset = false) {
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            getDistributionStationList(this.mainTable.tableSearch)
                .then((res) => {
                    if (res.code === 0) {
                        this.mainTable.data = res.data.records;
                        search.globalSetFilterRecordCount(
                            this.mainTable.tableSearch,
                            res.data.filterRecordCount
                        );

                        this.allRegionInfo = res.data.allRegionInfo;

                        this.provinceOptions = this.allRegionInfo.filter(
                            (r) => r.regionType === 1
                        );
                        this.cityOptions = [];
                        this.distOptions = [];
                    }

                    this.mainTable.loading = false;
                })
                .catch(() => {
                    this.mainTable.loading = false;
                });
        },
        onDistributionStationCreate() {
            this.distributionStationForm.formEditMode = FORM_EDIT_MODE_CREATE;
            this.distributionStationForm.distributionStationUuid = "";
            this.distributionStationForm.distributionStationName = "";
            this.distributionStationForm.distributionStationAddress = "";
            this.distributionStationForm.distributionStationAreaUuid = "";
            this.distributionStationForm.distributionStationDefaultLogisticsPerVolumePrice = 0;
            this.distributionStationForm.distributionStationProvince = "";
            this.distributionStationForm.distributionStationCity = "";
            this.distributionStationForm.distributionStationDist = "";
            this.distributionStationForm.distributionStationStreet = "";
            this.distributionStationForm.distributionStationFullAddress = "";
            this.distributionStationForm.distributionStationOperateDepartment
                = "";
            this.distributionStationForm.distributionStationLeader = "";
            this.distributionStationForm.distributionStationPhone = "";
            this.distributionStationForm.distributionStationX = "";
            this.distributionStationForm.distributionStationY = "";
            this.distributionStationForm.distributionStationCode = "";
            this.distributionStationForm.companyUuid = "";
            (this.distributionStationForm.departmentUuid = ""),
            (this.distributionStationFormShow = true);
        },
        onDistributionStationYsDeptUpdate(row) {
            this.distributionStationForm.distributionStationUuid
                = row.distributionStationUuid;
            this.distributionStationForm.distributionStationName
                = row.distributionStationName;
            this.distributionStationForm.distributionStationCode
                = row.distributionStationCode;
            this.distributionStationForm.distributionStationYsDeptId
                = row.distributionStationYsDeptId;
            this.distributionStationForm.distributionStationYsDeptCode
                = row.distributionStationYsDeptCode;
            this.distributionStationForm.distributionStationYsDeptName
                = row.distributionStationYsDeptName;

            this.distributionStationYsDeptFormShow = true;
        },
        onDistributionStationUpdate(row) {
            this.distributionStationForm.formEditMode = FORM_EDIT_MODE_MODIFY;
            this.distributionStationForm.distributionStationUuid
                = row.distributionStationUuid;
            this.distributionStationForm.distributionStationName
                = row.distributionStationName;
            this.distributionStationForm.distributionStationAddress
                = row.distributionStationAddress;
            this.distributionStationForm.distributionStationAreaUuid
                = row.distributionStationAreaUuid;
            this.distributionStationForm.distributionStationDefaultLogisticsPerVolumePrice
                = row.distributionStationDefaultLogisticsPerVolumePrice;
            this.distributionStationForm.distributionStationProvince
                = row.distributionStationProvince;
            this.distributionStationForm.distributionStationCity
                = row.distributionStationCity;
            this.distributionStationForm.distributionStationDist
                = row.distributionStationDist;
            this.distributionStationForm.distributionStationStreet
                = row.distributionStationStreet;
            this.distributionStationForm.distributionStationFullAddress
                = row.distributionStationFullAddress;
            this.distributionStationForm.distributionStationOperateDepartment
                = row.distributionStationOperateDepartment;
            this.distributionStationForm.distributionStationLeader
                = row.distributionStationLeader;
            this.distributionStationForm.distributionStationPhone
                = row.distributionStationPhone;
            this.distributionStationForm.distributionStationX
                = row.distributionStationX;
            this.distributionStationForm.distributionStationY
                = row.distributionStationY;
            this.distributionStationForm.distributionStationCode
                = row.distributionStationCode;
            this.distributionStationForm.distributionStationYsDeptId
                = row.distributionStationYsDeptId;
            this.distributionStationForm.distributionStationYsDeptCode
                = row.distributionStationYsDeptCode;
            this.distributionStationForm.distributionStationYsDeptName
                = row.distributionStationYsDeptName;
            this.distributionStationForm.departmentUuid = row.departmentUuid;
            this.distributionStationForm.companyUuid = row.companyUuid;

            this.onProvinceChange(
                this.distributionStationForm.distributionStationProvince
            );
            this.distributionStationForm.distributionStationCity
                = row.distributionStationCity;
            this.onCityChange(
                this.distributionStationForm.distributionStationCity
            );
            this.distributionStationForm.distributionStationDist
                = row.distributionStationDist;

            this.distributionStationFormShow = true;
        },
        onCancel() {
            this.distributionStationFormShow = false;
        },
        onSave() {
            // this.$refs.formDistributionStation.validate((valid) => {
            // if (valid) {
            const data = Object.assign({}, this.distributionStationForm);
            saveDistributionStation(data).then((res) => {
                if (res.code === 0) {
                    this.$Modal.success({
                        title: "保存成功",
                        onOk: () => {
                            this.distributionStationFormShow = false;
                            this.getDistributionStationTableRecords();
                        }
                    });
                }
            });
            // } else {
            //     this.$Message.error('请完善表单中带*号的项目');
            // }
            // })
        },
        onSaveYsDept() {
            this.$refs.formDistributionStationYsDept.validate((valid) => {
                if (valid) {
                    const data = Object.assign(
                        {},
                        this.distributionStationForm
                    );
                    saveDistributionStationYsDept(data).then((res) => {
                        if (res.code === 0) {
                            this.$Modal.success({
                                title: "保存成功",
                                onOk: () => {
                                    this.distributionStationYsDeptFormShow = false;
                                    this.getDistributionStationTableRecords();
                                }
                            });
                        }
                    });
                }
                else {
                    this.$Message.error("请完善表单中带*号的项目");
                }
            });
        },
        getYSDeptList() {
            getYSDeptList().then((res) => {
                if (res.code == 0) {
                    this.ySDeptList = res.data.deptList;
                }
            });
        },
        onSelectYSDept(value) {
            const matchedDept = this.ySDeptList.find(
                (item) => item.code === value
            );
            if (matchedDept) {
                this.distributionStationForm.distributionStationYsDeptId
                    = matchedDept.id;
                this.distributionStationForm.distributionStationYsDeptName
                    = matchedDept.name;
            }
        },
        async getDepartmentList() {
            try {
                const tableSearch = search.getSearchParams();
                search.closeAllConditions(tableSearch);
                const res = await getDepartmentList(tableSearch);
                if (res.code === 0) {
                    this.departmentList = res.data.records;
                }
                else {
                    this.$Message.error(res.message || "部门列表查询失败");
                }
            }
            catch (error) {
                console.error("获取部门列表失败:", error);
                this.$Message.error("部门列表查询失败");
            }
        },
        async getCompanyList() {
            try {
                const tableSearch = search.getSearchParams();
                search.closeAllConditions(tableSearch);
                const res = await getCompanyList(tableSearch);
                if (res.code === 0) {
                    this.companyList = res.data.records;
                }
                else {
                    this.$Message.error(res.message || "公司列表查询失败");
                }
            }
            catch (error) {
                console.error("获取公司列表失败:", error);
                this.$Message.error("公司列表查询失败");
            }
        }
    }
};
</script>

<style lang="less" scoped>
.form-button {
    margin-top: 5px;
}
</style>
